import * as RadixDropdownMenu from "@radix-ui/react-dropdown-menu";
import clsx from "clsx";
import DropDownMenuItem, {
  DropDownMenuItemProps,
} from "../../atoms/DropDownMenuItem";
import { ChevronRight, Menu } from "lucide-react";

type Props = {
  children?: React.ReactNode;
  menu: DropDownMenuItemProps[];
  icon?: React.ReactNode;
  showArrow?: boolean;
};

const dropDownPanelClasses = clsx(
  "bg-background border border-border rounded-sm shadow-lg p-2 min-w-36"
);

const DropdownMenu = ({ children, menu, icon, showArrow = true }: Props) => {
  return (
    <RadixDropdownMenu.Root>
      <RadixDropdownMenu.Trigger asChild>
        <button className="IconButton flex items-center gap-2">
          <div>{children}</div>
          <div className="hidden lg:block">
            {icon || <Menu className="h-6 w-6" />}
          </div>
        </button>
      </RadixDropdownMenu.Trigger>
      <RadixDropdownMenu.Portal>
        <RadixDropdownMenu.Content
          className={`DropdownMenuContent ${dropDownPanelClasses}`}
          sideOffset={8}
        >
          {menu.map(({ items, ...item }) =>
            items?.length ? (
              <RadixDropdownMenu.Sub key={item.key}>
                <RadixDropdownMenu.SubTrigger className="DropdownMenuSubTrigger py-1 flex items-center justify-between cursor-pointer">
                  {item.children}
                  <div className="RightSlot pl-3">
                    <ChevronRight />
                  </div>
                </RadixDropdownMenu.SubTrigger>
                <RadixDropdownMenu.Portal>
                  <RadixDropdownMenu.SubContent
                    className={`DropdownMenuSubContent ${dropDownPanelClasses}`}
                    sideOffset={2}
                    alignOffset={-5}
                  >
                    {items.map((item) => (
                      <DropDownMenuItem {...item} key={item.key}/>
                    ))}
                  </RadixDropdownMenu.SubContent>
                </RadixDropdownMenu.Portal>
              </RadixDropdownMenu.Sub>
            ) : (
              <DropDownMenuItem {...item} key={item.key} onClick={item.onClick} />
            )
          )}
          {showArrow && (
            <RadixDropdownMenu.Arrow className="DropdownMenuArrow" />
          )}
        </RadixDropdownMenu.Content>
      </RadixDropdownMenu.Portal>
    </RadixDropdownMenu.Root>
  );
};

export default DropdownMenu;
